
/* injects from baggage-loader */
require('./style.scss');

		
import React from "react";
import { connect } from "react-redux";
import { t } from "../../../helpers/translator";
import { OpenPopup } from "../../../actions/ui";
import infoPic from '../../../images/info-icon.png'
import { CASHOUT_MONEY_WITH_FEE } from '../../../actions/actionTypes'
import Config from "../../../config/main";
const CashoutByBankCard = ({ dispatch }) => { 
    return (
        <div className='cashout-card-container'>
            <p className='cashout-card-title'>{t("Cash Out")}</p>
            <p className='cashout-card-sub-title'>{t(`${Config.main.cashoutCommissionPercent}% commission will be charged for cashing. You can transfer money to your account to avoid interest.`)}</p>
            <img alt='info-icon' src={infoPic}/>
            <div className='buttons-container'>
                <button
                    className='button-view-normal-m'
                    onClick={() => dispatch(OpenPopup("transferToAccount"))}
                >
                    {t('Transfer To Account')}
                </button>
                <button
                    className='button-view-normal-m cancel'
                    onClick={() => dispatch({ type: CASHOUT_MONEY_WITH_FEE })}
                >
                    {t('Cash Out')}
                </button>
            </div>
        </div>
    )
}
export default connect()(CashoutByBankCard)